import {useQuery, UseQueryResult} from "@tanstack/react-query";
import {CustomAxiosError, useApiCalls} from "../../../../../../logics/api_config";
import {useAuth} from "../../../../../../utils/contexts/auth-context";
import {IProject} from "../../../../../../utils/interfaces/my_projects/IProject";


const useApiGetProject = (pk: number | undefined): UseQueryResult<IProject, CustomAxiosError> => {
    const {selectedCompany} = useAuth();

    const {get} = useApiCalls()

    async function doGet(pk: number | undefined): Promise<IProject> {
        try {
            const response = await get(`/api/company/${selectedCompany?.company_token}/my_projects/projects/${pk}`);
            return response?.data;
        } catch (error) {
            throw error;
        }
    }

    return useQuery({
        queryKey: ["useApiGetProject", pk],
        queryFn: () => doGet(pk),
        enabled: !!pk,
    })

};

export default useApiGetProject